<app-main>
    <form [formGroup]="form">
      <div class="syncro-field">
        <mat-form-field style="width: 250px">
          <mat-label>Choisissez une date de syncro</mat-label>
          <mat-select [(value)]="selectedSyncro" formControlName="syncro">
            @for (syncro of allSyncro; track syncro) {
            <mat-option [value]="syncro">{{
              syncro.date | date : "dd/MM/yyyy à HH:mm"
            }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>

    <div class="dashboard-container">
        <h1><mat-icon>bar_chart</mat-icon> Tableau de bord des statistiques</h1>
      
        <!-- Section DIVALTO -->
        <section>
          <h2>Divalto</h2>
          <div class="stats-grid">
            <mat-card class="stat-card">
              <mat-card-title>Nb Clients</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalClientsDivalto) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb Postes</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalPostesDivalto) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb Serveurs</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalServeursDivalto) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb Équipements</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalEquipementsDivalto) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb ATS</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalATSDivalto) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb EDR</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalEDRDivalto) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb MDR</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalMDRDivalto) }}</mat-card-content>
            </mat-card>
          </div>
        </section>
      
        <!-- Section RG -->
        <section>
          <h2>RG</h2>
          <div class="stats-grid">
            <mat-card class="stat-card">
              <mat-card-title>Nb Postes</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalPostesRG) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb Serveurs</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalServeursRG) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb Équipements</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalEquipementsRG) }}</mat-card-content>
            </mat-card>
          </div>
        </section>
      
        <!-- Section BIT -->
        <section>
          <h2>BIT</h2>
          <div class="stats-grid">
            <mat-card class="stat-card">
              <mat-card-title>Nb Postes</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalPostesBIT) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb Serveurs</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalServeursBIT) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb ATS</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalATSBIT) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb EDR</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalEDRBIT) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>Nb MDR</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.totalMDRBIT) }}</mat-card-content>
            </mat-card>
          </div>
        </section>
      
        <!-- Section ÉCARTS -->
        <section>
          <h2>Écarts</h2>
          <div class="stats-grid">
            <mat-card class="stat-card">
              <mat-card-title>RG Postes</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.ecartRGPostes) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>RG Serveurs</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.ecartRGServeurs) }}</mat-card-content>
            </mat-card>

            <mat-card class="stat-card">
                <mat-card-title>RG Équipements</mat-card-title>
                <mat-card-content>{{ formatNumber(stats?.ecartRGEquipements) }}</mat-card-content>
              </mat-card>

            <mat-card class="stat-card">
                <mat-card-title>BIT Postes</mat-card-title>
                <mat-card-content>{{ formatNumber(stats?.ecartBITPostes) }}</mat-card-content>
              </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>BIT Serveurs</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.ecartBITServeurs) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>ATS</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.ecartATS) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>EDR</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.ecartEDR) }}</mat-card-content>
            </mat-card>
      
            <mat-card class="stat-card">
              <mat-card-title>MDR</mat-card-title>
              <mat-card-content>{{ formatNumber(stats?.ecartMDR) }}</mat-card-content>
            </mat-card>
          </div>
        </section>
      
        <!-- Section POURCENTAGES -->
        <section>
          <h2>Pourcentages clients avec modules</h2>
          <div class="progress-grid">
            <div class="progress-item">
              <span>ATS</span>
              <mat-progress-bar mode="determinate" [value]="stats?.pourcentageClientsATS || 0"></mat-progress-bar>
              <span>{{ formatPercentage(stats?.pourcentageClientsATS) }}</span>
            </div>
            <div class="progress-item">
              <span>EDR</span>
              <mat-progress-bar mode="determinate" [value]="stats?.pourcentageClientsEDR || 0"></mat-progress-bar>
              <span>{{ formatPercentage(stats?.pourcentageClientsEDR) }}</span>
            </div>
            <div class="progress-item">
              <span>MDR</span>
              <mat-progress-bar mode="determinate" [value]="stats?.pourcentageClientsMDR || 0"></mat-progress-bar>
              <span>{{ formatPercentage(stats?.pourcentageClientsMDR) }}</span>
            </div>
          </div>
        </section>
      </div>
      </app-main>
      <ngx-spinner
      bdColor="rgba(0,0,0,0.8)"
      size="medium"
      color="#fff"
      type="ball-spin-clockwise"
      [fullScreen]="true"
    ></ngx-spinner>
    